export default {
    en: {
        id: 'exercise4',
        subtitle: 'SUGGESTED STRUCTURE <br> ANALYSIS OF TECHNOLOGY ALTERNATIVES',
        blocks: [
            {
                task: 'Must replace Unisys HW in next 3-4 years',
                title: "S = ",
                answer: ' ',
                note: 'Sit, DE, R1, R2',
                disableEdit: true
            },
            {
                task: 'Can either upgrade, migrate to new system, or outsource. Would rather not outsource.',
                title: "C = ",
                answer: ' ',
                note: 'Sol',
                disableEdit: true
            },
            {
                task: 'What do?',
                title: "Q = ",
                answer: ' ',
                disableEdit: true
            }
        ],
        image: '5b2-4.png',
        withoutAnswers: true,
        hideTaskTitle: true,
        submitButton: 'switch'
    },
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5b/practiceDefiningProblem/i18n/exercise4.js